import React from 'react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';
import { Switch } from '../ui/switch';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { STATUS_OPTIONS, SYSTEM_OPTIONS } from './constants';

const AcademicProfileModal = ({ state, setState, onSave }) => {
  const set = (patch) => setState(s => ({ ...s, data: { ...s.data, ...patch } }));
  return (
    <Dialog open={state.open} onOpenChange={(o) => setState(s => ({ ...s, open: o }))}>
      <DialogContent className="max-w-2xl">
        <DialogHeader><DialogTitle>{state.editing ? 'Edit Academic Profile' : 'Add Academic Profile'}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3 max-h-[60vh] overflow-y-auto">
          <div className="col-span-2">
            <Label>Profile name *</Label>
            <Input value={state.data.profile_name || ''} onChange={e => set({ profile_name: e.target.value })}
                   placeholder="e.g. Portuguese School, American Programme" data-testid="profile-name-input" />
          </div>
          <div>
            <Label>School / provider</Label>
            <Input value={state.data.school_or_provider_name || ''} onChange={e => set({ school_or_provider_name: e.target.value })} data-testid="profile-school-input" />
          </div>
          <div>
            <Label>Programme / course</Label>
            <Input value={state.data.programme_or_course_name || ''} onChange={e => set({ programme_or_course_name: e.target.value })} data-testid="profile-program-input" />
          </div>
          <div>
            <Label>System</Label>
            <Select value={state.data.academic_system || 'Portuguese'} onValueChange={v => set({ academic_system: v })}>
              <SelectTrigger data-testid="profile-system-select"><SelectValue /></SelectTrigger>
              <SelectContent>{SYSTEM_OPTIONS.map(o => <SelectItem key={o} value={o}>{o}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <Label>Current grade / year</Label>
            <Input value={state.data.current_grade_or_year || ''} onChange={e => set({ current_grade_or_year: e.target.value })} data-testid="profile-grade-input" />
          </div>
          <div>
            <Label>Status</Label>
            <Select value={state.data.status || 'Good'} onValueChange={v => set({ status: v })}>
              <SelectTrigger data-testid="profile-status-select"><SelectValue /></SelectTrigger>
              <SelectContent>{STATUS_OPTIONS.map(o => <SelectItem key={o} value={o}>{o}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <Label>Teacher / tutor</Label>
            <Input value={state.data.responsible_teacher_or_tutor || ''} onChange={e => set({ responsible_teacher_or_tutor: e.target.value })} />
          </div>
          <div>
            <Label>Start date</Label>
            <Input type="date" value={state.data.start_date || ''} onChange={e => set({ start_date: e.target.value })} />
          </div>
          <div>
            <Label>Expected end date</Label>
            <Input type="date" value={state.data.expected_end_date || ''} onChange={e => set({ expected_end_date: e.target.value })} />
          </div>
          <div className="col-span-2">
            <Label>Notes</Label>
            <Textarea rows={3} value={state.data.notes || ''} onChange={e => set({ notes: e.target.value })} />
          </div>
          {/* Phase 75.1 — optional course completion % tracking. OFF by default.
              Surfaces the Completion % input on subject rows in the Programme
              Reports & Grades panel when enabled. */}
          <div className="col-span-2 border-t border-gray-200 dark:border-gray-700 pt-3 mt-1">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <Label htmlFor="track-course-completion-switch" className="cursor-pointer">
                  Track Course Completion %
                </Label>
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1" data-testid="track-course-completion-helper">
                  Use this for programmes where students complete subjects by percentage or modules.
                  This is separate from the grade.
                </p>
              </div>
              <Switch
                id="track-course-completion-switch"
                checked={!!state.data.track_course_completion}
                onCheckedChange={(v) => set({ track_course_completion: !!v })}
                data-testid="track-course-completion-switch"
              />
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setState(s => ({ ...s, open: false }))}>Cancel</Button>
          <Button onClick={onSave} data-testid="save-profile-btn">{state.editing ? 'Save changes' : 'Create profile'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AcademicProfileModal;
